<div class="c-block c-block--bordered">
  <dl class="c-detail__list mb-3">
    <dt class="c-detail__list-name">Applicant Details</dt>
    <dt class="c-detail__list-title">Is this a company application?</dt>
    <dd class="c-detail__list-description">{{IsCompanyApplication}}</dd>
  </dl>
  <div class="row">
    @for (a of Applicants; track a) {
      <div class="col-12" [ngClass]="Applicants.length > 1 ? 'col-md-6' : ''">
        <recap-applicant
          [applicant]="a"
          [addressMatchDoneAlready]="addressMatchDoneAlready"
          [doAddressMatch]="doAddressMatch"
        (outputApplicant)="receiveApplicant($event)"></recap-applicant>
      </div>
    }
  </div>
  @if (showEditButton) {
    <button class="c-button c-button--neutral" type="button" (click)="editButtonClicked()">
      Edit applicant details
      <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.06 14.71"><path fill="none" stroke="#2f3432" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7" /></svg>
    </button>
  }
</div>
